if (!customElements.get('cart-shipping-bar')) {
  class CartShippingBar extends HTMLElement {
    static lastProgress = null;
    static lastMessage = null;

    connectedCallback() {
      const fill = this.querySelector('.cart-shipping-bar__fill');
      const progress = Number(this.dataset.progress) || 0;
      const message = this.querySelector('.cart-shipping-bar__message')?.textContent.trim() || '';
      const prevProgress = CartShippingBar.lastProgress;
      const prevMessage = CartShippingBar.lastMessage;
      CartShippingBar.lastProgress = progress;
      CartShippingBar.lastMessage = message;

      if (prevProgress === null) return;

      if (message && message !== prevMessage) {
        const region = this.querySelector('[data-shipping-bar-announce]');
        if (region) setTimeout(() => { region.textContent = message; }, 150);
      }

      if (progress >= 100 && prevProgress < 100) this.classList.add('is-just-reached');

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!fill || prevProgress === progress || reduceMotion) return;

      fill.style.transition = 'none';
      fill.style.width = `${prevProgress}%`;
      fill.getBoundingClientRect();
      requestAnimationFrame(() => {
        fill.style.transition = '';
        fill.style.width = '';
      });
    }
  }
  customElements.define('cart-shipping-bar', CartShippingBar);
}
